import ReactNumberFormat from 'react-number-format';
import styled from 'styled-components';
import BigNumber from 'bignumber.js';

import { cFFFFFF } from '#/colors';

import SETTINGS from '#/config/global-settings';

import Field from '#/components/shared/Field';
import BaseMaxButton from '#/components/shared/MaxButton';

import {
  useWithdrawFormActions,
  useWithdrawFormView,
} from '#/features/withdraw/form-context';
import { useWithdrawView } from '#/features/withdraw/withdraw-context';
import { useAccountState } from '#/features/account/account-context';

import useLabel from '#/utils/useLabel';

export default function InputAmount() {
  const accountState = useAccountState();
  const withdrawView = useWithdrawView();
  const formView = useWithdrawFormView();
  const formActions = useWithdrawFormActions();
  const [label, labelId] = useLabel('amount');

  const setMaxAmount = () => {
    if (accountState.account == null) return;
    const freeCollateral = accountState.account.free_collateral;
    const maxAmount = freeCollateral.toFixed(
      SETTINGS.fiat.USD.scale,
      BigNumber.ROUND_DOWN,
    );
    formActions.updateAmount(maxAmount);
  };

  return (
    <div css="display: grid; gap: 8px;">
      <Field label={label} labelId={labelId}>
        <NumberFormat
          id={labelId}
          thousandSeparator
          decimalScale={SETTINGS.fiat.USD.scale}
          allowNegative={false}
          isNumericString
          placeholder="0.00"
          value={formView.amount.value}
          onValueChange={({ value }) => formActions.updateAmount(value)}
          disabled={withdrawView.isBusy}
        />
        <MaxButton
          css="position: relative; right: -8px;"
          onClick={setMaxAmount}
        />
      </Field>
    </div>
  );
}

const MaxButton = styled(BaseMaxButton)`
  position: relative;
  right: -8px;
`;

const NumberFormat = styled(ReactNumberFormat)`
  flex-grow: 1;
  height: 100%;
  background-color: transparent;
  border: none;
  color: ${cFFFFFF};
  font-size: 14px;
  font-family: 'Roboto Mono' monospace;
`;
